import styled from "styled-components";
import { NavLink } from "react-router-dom";

const Com = {};

Com.ImgMain = styled.img`
    position: absolute; 
    top:0; 
    left: 0;
    width:100%;
    height: 100%;
    background-attachment: fixed;
    background-position: 50% 50%;
    background-size: cover;
    filter: brightness(50%);
    object-fit:cover;
`

Com.DivMiddleImg = styled.div`
    width: 100%;
    margin: 0 auto 120px;
    position: relative;
    overflow: hidden;

    & > p {
        margin: 0;
    }

    & picture {
        display: block;
        width: 100%;
    }
    
    @media all and (max-width: 768px){
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
        margin: 0 auto 0px;
    }
`

Com.DivCompImg = styled.div`
    width: 100%;
    margin: 20px auto 20px;
    position: relative;
    overflow: hidden;
    
    @media all and (max-width: 768px){
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
        margin: 0 auto 0px;
    }
`

Com.MiddleGridImg = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        -o-object-fit: cover;
        object-fit: cover;
        margin: auto;
        display: block;

        @media all and (max-width: 768px){
            width: 50%;
        }

        @media all and (max-width: 480px){
            width: 70%;
        }
    }
`

Com.MiddleGridImg2 = styled.img`
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        width: ${props=>props.width};
        height: ${props=>props.height};
        -o-object-fit: cover;
        object-fit: cover;
        margin: auto;
        display: block;

        @media all and (max-width: 768px){
            width: 80%;
        }

        @media all and (max-width: 480px){
            width: 90%;
        }
    }
`

Com.MiddleImg = styled.img`
    width: ${props=>props.width || '100%'};
    height: ${props=>props.height || 'auto'};
    margin: 0;
    display: block;
    @supports ((-o-object-fit:cover) or (object-fit:cover)){
        -o-object-fit: cover;
        object-fit: cover;
    }
`

// HyGateOne 슬라이드 등 전체 내용이 보여야 하는 이미지
Com.ContainImg = styled.img`
    width: ${props=>props.width};
    height: ${props=>props.height};
    margin: 16px auto 0;
    display: block;
    object-fit: contain;
`

Com.DivDetailSection = styled.section`
    max-width: 780px;
    margin: 80px auto;

    @media all and (max-width: 768px){
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
            
    }
    }

    @media all and (max-width: 768px){
        padding: 80px 20px 20px;
    }
`

Com.DivGridDetailSection = styled.section`
    max-width: 810px;
    margin: 80px auto;

    @media all and (max-width: 768px){
        margin: 6px auto 60px;
        padding: 80px 50px 20px;
        position: relative;
        border-top: ${props=>
            props.border==="false"?"0px solid" :"8px solid #ebeef2"
            
    }
    }

    @media all and (max-width: 768px){
        padding: 80px 20px 20px;
    }
`

Com.DivDetailHeading = styled.div`
    padding: 0 24px;
    text-align: center;
    word-break: keep-all;
    margin-bottom: 15px;

    @media all and (max-width: 768px){
        padding: 0 24px;
        text-align: center;
        word-break: keep-all;
    }
`
    
Com.DivImgSub = styled.div`
    
    margin-bottom: 3px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 20px;
    padding-top: 40px;

    @media all and (max-width: 768px){
        grid-template-columns: none;
    }
    
`

Com.DivImgSub2 = styled.div`
    
    margin-bottom: 3px;
    display: grid;
    grid-template-columns: 1.3fr 1fr;
    margin-top: 20px;
    padding-top: 40px;

    @media all and (max-width: 768px){
        grid-template-columns: none;
    }
    
`

Com.DetailHeading = styled.h3`
    
    margin-bottom: 3px;
    font-size: 34px;
    font-family: 'Esamanru';
    font-weight: 500;
    line-height: 1.5;

    @media all and (max-width: 768px){
        font-size: 30px;
        line-height: 1.4;
    }
`

Com.DetailHeadingP = styled.p`
    
    margin-bottom: 25px;
    font-size: 14px;
    font-family: 'Esamanru';
    font-weight: 500;
    line-height: 1.5;
    color: #393939;

    @media all and (max-width: 768px){
        font-size: 30px;
        line-height: 1.4;
    }
`

Com.DetailHeadingSmall = styled.small`
    line-height: 1.75;
    font-size: 18px;
    font-family: 'Pretendard';
    font-weight: 300;
    letter-spacing: -.07em;
    word-spacing: 0.05em;
`

Com.StrongStrategy = styled.strong`
    font-size: 20px; 
    font-family: 'Esamanru';
    font-weight: 500;
    line-height: 30px;
    letter-spacing: -0.3px;
    position: relative;
    top: 2px;
    //text-decoration: ${props=>props.underline===true?"underline":"none"};
    border-bottom: ${props=>props.underline===true?"1.5px solid #272727":"none"};
`

Com.SpanStrategy = styled.strong`
    font-size: 18px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-top: 4px;
    margin-right: 12px;
    color: #fff;
    font-weight: 500;
    border-radius: 50%;
    background-color: #232324;
    font-family: "Esamanru";
`
Com.BtnTagList = styled.button`
    color: black;
    font-size: 17px;
    font-weight: 400;
    margin: 10px 8px 0;
    border-radius: 18px;
    background-color: white;
    border: 1px solid;
    border-color: #A4A4A4;
    cursor: default;
    font-family: 'Pretendard';
    font-weight: 500;
    font-size: 17px;
    width: ${props=>props.width};
    height: 40px;

    @media all and (max-width: 480px){
        width: 170px;
    }
`

Com.OlProcessFlow = styled.ol`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 14px;
    margin-top: 36px;
    list-style: none;

    @media all and (max-width: 768px){
        grid-template-columns: 1fr;
        gap: 24px;
        margin-top: 28px;
    }
`

Com.LiProcessStep = styled.li`
    position: relative;
    min-height: 190px;
    padding: 24px 18px;
    border: 1px solid #e2e7ec;
    border-radius: 20px;
    background: #ffffff;

    &:not(:last-child)::after {
        content: '›';
        position: absolute;
        top: 50%;
        right: -12px;
        z-index: 1;
        color: #4f91cf;
        font-size: 28px;
        line-height: 1;
        transform: translateY(-50%);
    }

    @media all and (max-width: 768px){
        min-height: auto;
        padding: 22px 20px;

        &:not(:last-child)::after {
            content: '↓';
            top: auto;
            right: auto;
            bottom: -22px;
            left: 50%;
            font-size: 18px;
            transform: translateX(-50%);
        }
    }
`

Com.SpanProcessNumber = styled.span`
    display: block;
    margin-bottom: 14px;
    color: #2f82c9;
    font-family: 'Esamanru';
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.08em;
`

Com.StrongCardTitle = styled.strong`
    display: block;
    color: #17283a;
    font-family: 'Esamanru';
    font-size: 18px;
    font-weight: 500;
    line-height: 1.45;
`

Com.PCardDescription = styled.p`
    margin-top: 12px;
    color: #526171;
    font-family: 'Pretendard';
    font-size: 15px;
    font-weight: 300;
    line-height: 1.65;
    word-break: keep-all;
`

Com.DivMetricGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
    margin-top: 36px;

    @media all and (max-width: 768px){
        grid-template-columns: 1fr;
        margin-top: 28px;
    }
`

Com.ArticleMetricCard = styled.article`
    padding: 30px 24px;
    border-radius: 22px;
    background: #102a43;
    color: #ffffff;
    text-align: center;
`

Com.SpanMetricLabel = styled.span`
    display: block;
    margin-bottom: 10px;
    color: #a9d7ff;
    font-family: 'Pretendard';
    font-size: 14px;
    font-weight: 500;
`

Com.StrongMetricValue = styled.strong`
    display: block;
    font-family: 'Esamanru';
    font-size: 30px;
    font-weight: 500;
    line-height: 1.3;
`

Com.PMetricDescription = styled.p`
    margin-top: 12px;
    color: #d8e8f5;
    font-family: 'Pretendard';
    font-size: 15px;
    font-weight: 300;
    line-height: 1.6;
    word-break: keep-all;
`

Com.DivCloudCallout = styled.div`
    margin: 100px auto 80px;
    padding: 52px 40px;
    border-radius: 28px;
    background: linear-gradient(135deg, #102a43 0%, #1768a8 100%);
    color: #ffffff;
    text-align: center;

    @media all and (max-width: 768px){
        margin: 60px 20px;
        padding: 40px 22px;
    }
`

Com.H3CalloutTitle = styled.h3`
    font-family: 'Esamanru';
    font-size: 28px;
    font-weight: 500;
    line-height: 1.45;

    @media all and (max-width: 480px){
        font-size: 24px;
    }
`

Com.PCalloutDescription = styled.p`
    margin-top: 14px;
    color: #d8e8f5;
    font-family: 'Pretendard';
    font-size: 17px;
    font-weight: 300;
    line-height: 1.7;
    word-break: keep-all;
`

Com.DivCalloutActions = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 28px;

    @media all and (max-width: 480px){
        flex-direction: column;
    }
`

Com.LinkCalloutPrimary = styled(NavLink)`
    display: inline-flex;
    min-width: 210px;
    height: 50px;
    align-items: center;
    justify-content: center;
    padding: 0 22px;
    border: 1px solid #ffffff;
    border-radius: 25px;
    background: #ffffff;
    color: #102a43;
    font-family: 'Pretendard';
    font-size: 16px;
    font-weight: 600;
    transition: 0.2s ease;

    &:hover {
        background: transparent;
        color: #ffffff;
    }
`

Com.AnchorCalloutSecondary = styled.a`
    display: inline-flex;
    min-width: 210px;
    height: 50px;
    align-items: center;
    justify-content: center;
    padding: 0 22px;
    border: 1px solid rgba(255, 255, 255, 0.65);
    border-radius: 25px;
    color: #ffffff;
    font-family: 'Pretendard';
    font-size: 16px;
    font-weight: 600;
    transition: 0.2s ease;

    &:hover {
        border-color: #ffffff;
        background: rgba(255, 255, 255, 0.12);
    }
`

Com.BtnNavBarClose = styled.button`

    svg {
        vertical-align: top;
        width: 14px;
        height: 14px;
    }
    @media all and (max-width: 1024px) {
        line-height: 0;
        margin-right: -16px;
        padding: 16px;
    }
`

Com.H3PageHeadTitle = styled.h3`
    text-align: center;
    color: #232324;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5238095238;
    font-family: 'Esamanru';
    font-weight: 500;
    margin-top: 20px;
`
Com.DivMap = styled.div`
    width : min(100%, 600px);
    height: 400px;
    margin: 0 auto;
    border: 0;
    object-fit: cover;
`;

Com.OlBangHyang = styled.ol`
    display: grid;
    grid-gap: 60px 0px;
    grid-template-columns: 1fr 1fr;
    max-width: 768px;
    padding-left: 50px;

    li {
        margin-left: auto;
        margin-right: auto;
    }

    @media all and (max-width: 768px){
        display: grid;
        text-align: center;
        grid-gap: 20px;
        position: relative;
        padding: inherit;
    }

    @media all and (max-width: 480px){
        grid-template-columns: 3fr;
    }
`

Com.POpWay = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: ${props=>props.width};
    padding: 0 15px;
    // line-height: 1.7142857143;
    color: white;
    background-color: black;
    border-radius: 18px;
    font-family: 'Esamanru';
    font-weight: 500;
    font-size: 20px;
`;

Com.OlInOl = styled.ol`
    flex: none;
    width: 100%;
    margin-top: 20px;
    counter-reset:list-number;
    text-align: left;
    font-family: 'Pretendard';
    font-weight: 300;
    font-size: 17px;

    li {
        margin-bottom: 14px;
        counter-increment:list-number;
    }

    li:before {
        content: counter(list-number) '. ';
    }
`;

Com.DivBoardList = styled.div`
    max-width: 1020px;
    margin: 0 auto 60px;
    padding: 0 50px;

    @media all and (max-width: 768px){
        margin: 0 24px 80px;
    }
`

Com.DivBoardBox = styled.div`
    border-bottom: 1px solid #f3f4f5;
`

Com.LinkBoard = styled(NavLink)`
    display: flex;
    flex-wrap: wrap;
    padding: 40px 20px;

    @media all and (max-width: 768px){
        position: relative;
        padding: 30px 0;
    }
`

Com.DivBoardContent = styled.div`
    -webkit-box-flex: 1;
    flex: 1;
    overflow: hidden;

    @media all and (max-width: 768px){
        position: relative;
    }
`

Com.DivBoardTitle = styled.div`
    font-weight: 700;
    display: -webkit-box;
    color: #232324;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 64px;
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 1.6;
    font-family: 'Pretendard';

    @media all and (max-width: 768px){
        max-height: 52px;
        margin-bottom: 5px;
        font-size: 16px;
        line-height: 1.625;    
    }
`

Com.TimeBoard = styled.time`
    position: relative;
    color: #a6a7a9;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.7142857143;
    font-family: 'Pretendard';

    @media all and (max-width: 768px){
        font-size: 12px;
        line-height: 1.6666666667;
    }
`

Com.DivLoading = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-height: 200px;
    padding: 60px;
`

Com.MainArticle = styled.main`
    padding-bottom: 160px;
    margin-top: 0;
    padding-top: 72px;

    @media all and (max-width: 1024px){
        padding-top: 50px;
    }
`

Com.SectionArticle = styled.section`
    max-width: 780px;
    margin: 0 auto 0;
    padding-top: 80px;

    @media all and (max-width: 768px){
        margin-bottom: 120px;
        padding-top: 60px;
    }
`

Com.DivArticleHead = styled.div`
    padding-bottom: 80px;
    text-align: center;
    border-bottom: 1px solid #d6d7da;

    @media all and (max-width: 768px){
        padding: 0 24px 80px;
        border-bottom: 10px solid #ebeef2;
    }
`

Com.DivArticleMeta = styled.div`
    margin-bottom: 20px;
`

Com.DivBtnWrap = styled.div`
    text-align: center;
    font-family: 'Pretendard';
    font-weight: 400;
    font-size: 17px;
`
Com.BodyWrapper = styled.div`
    margin: 0;
    padding: 400px 0 360px 0;
    background-color: #f5f5f5;
    color: #000000;
    margin-bottom: 100px;
`;

Com.Header = styled.div`
    text-align: left;
    margin-bottom: 50px;

    h1 {
        font-size: 2.5em;
        color: #4a3e3c;
        margin-bottom: 5px;
    }

    p {
        font-size: 1.2em;
        color: #8c7e7b;
    }
`;

Com.TimelineContainer = styled.div`
    position: relative;
    max-width: 1500px;
    margin: 0 auto;
    padding: 50px 0;

    &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: #4f52e3;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 1;
    }

    &::before,
    &::after {
        content: "";
        display: table;
        clear: both;
    }

    @media (max-width: 768px) {
        &::after {
            left: 50%;
            transform: translateX(-50%);
            width: 3px;
            height: 100%;
            top: 0;
        }
    }
`;

Com.TimelineItem = styled.div`
    position: absolute;
    ${props => props.$width && `width: ${props.$width};`}
    padding: 20px;
    box-sizing: border-box;
    z-index: 2; 
    text-align: center; 
    ${props => props.$top && `top: ${props.$top};`}
    ${props => props.$left && `left: ${props.$left};`}

    ${props => props.$position === 'left' && `
        float: left;
        //clear: both; 
        margin-bottom: 100px;
    `}

    ${props => props.$position === 'right' && `
        float: right;
        //clear: both;
        margin-top: 100px;
    `}

    @media (max-width: 768px) {
        width: 100%;
        float: none;
        clear: both;
        margin: 20px 0 !important; /* Override specific margins */
    }
`;

Com.TimelineYear = styled.div`
    font-size: 1.5em;
    font-weight: bold;
    color: #6a5e5b;
    margin-bottom: 15px;
`;

Com.TimelineMarker = styled.div`
    width: 10px;
    height: 10px;
    background-color: #4f52e3; 
    border: 3px solid #4f52e3;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3; 
    position: relative;

    ${props => props.$position === 'bottom' && `
        margin: 15px auto 0 auto;   
    `}

     ${props => props.$position === 'top' && `
        margin: 0 auto 15px auto;   
    `}

    ${props => props.$isTop && `
        &::before {
            content: '';
            position: absolute;
            bottom: 100%; 
            left: 50%;
            transform: translateX(-50%);
            width: 2px; 
            height: 30px; 
            background-color: #4f52e3; 
            z-index: 1; 
        }
    `}

    ${props => props.$isBottom && `
        &::after {
            content: '';
            position: absolute;
            top: 100%; 
            left: 50%;
            transform: translateX(-50%);
            width: 2px;
            height: 31px; 
            background-color: #4f52e3; 
            z-index: 1;
        }
    `}

    @media (max-width: 768px) {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0;
    }
`;

Com.ContentBox = styled.div`
    background-color: #ffffff; 
    border: 1px solid #dcdcdc; 
    padding: 15px;
    border-radius: 8px;
    //box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
    text-align: left; 
    margin-top: 15px; 

    h3 {
        font-size: 16px;
        color: #000000;
        margin-bottom: 8px;
        font-weight: bold;
        font-family: "'Pretendard'";
    }

    p {
        font-size: 14px;
        color: #000000;
        line-height: 1.5;
        font-weight: normal;
        font-family: "'Pretendard'";
    }

    @media (max-width: 768px) {
        margin-top: 50px;
    }
`;

Com.TimelineYearOnLine = styled.div`
    position: absolute;
   ${props => props.$top && `top: ${props.$top};`}
    transform: translateY(-50%);
    font-weight: bold;
    color: #4f52e3;
    z-index: 4;
    ${props => props.$left && `left: ${props.$left};`}
    font-size: 18px;
    font-family: "'Pretendard'";
`;

Com.Container = styled.div`
  padding: 0 20px 0 0;
  max-width: 90%;
  margin: 0  0 auto;
  font-family: 'Pretendard';
  padding-bottom: 5vw;
`;

Com.TabWrapper = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 30px;
`;

Com.TabButton = styled.button`
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 14px;
  border: 1px solid ${({ active }) => (active ? '#000' : '#ccc')};
  background-color: ${({ active }) => (active ? '#000' : '#f3f4f6')};
  color: ${({ active }) => (active ? '#fff' : '#374151')};
  cursor: pointer;
`;

Com.TimelineGrid = styled.div`
  display: grid;
  grid-template-columns:110px 20px 1fr; 
  gap: 0;
  position: relative;

  @media all and (max-width: 768px){
    grid-template-columns: 1fr; /* stack: year -> items */
  }
`;

Com.YearGroup = styled.div`
  display: contents;
`;

Com.YearCell = styled.div`
  font-size: 27px;
  font-weight: bold;
  color: #111827;
  text-align: right;
  padding-right: 25px;
  line-height: 27px;

  @media all and (max-width: 768px){
    text-align: left;
    padding-right: 0;
    margin: 24px 0 12px;
  }
`;

Com.LineCell = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1.5px;
    background-color: #3b82f6;
  }

  @media all and (max-width: 768px){
    display: none; /* hide middle line and dot on mobile to avoid clipping */
  }
`;

Com.Dot = styled.div`
  width: 12px;
  height: 12px;
  background-color: #3b82f6;
  border-radius: 50%;
  border: 2px solid white;
  position: relative;
  z-index: 1;
`;

Com.ItemsCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 23px;
  padding-left: 20px;
  padding-bottom: 33px;
  text-align: left;

  @media all and (max-width: 768px){
    padding-left: 0;
    padding-bottom: 24px;
  }
`;

Com.TimelineItem = styled.div`
  display: flex;
  gap: 10px;
  font-size: 16px;
  color: #1f2937;
  line-height: 23px;
  text-align: left;
  align-items: flex-start;
`;

Com.Month = styled.span`
  font-weight: 700;
  color: #6b7280;
`;

export default Com;
